import { ExarePriceDetailsPriceElementType } from '@websky/graphql';
import { getTotalPrice } from '../../../utils';
import { Currency } from '../../../enums';
import { getCurrency } from '../../../cache';
export const isFareOrServicesNotEmpty = (refunded) => refunded.elements.some(element => element.type === ExarePriceDetailsPriceElementType.fare ||
    element.type === ExarePriceDetailsPriceElementType.gdsServiceFare);
export const isRetentionNotEmpty = (prices) => { var _a, _b; return ((_b = (_a = prices.priceDetails.retention) === null || _a === void 0 ? void 0 : _a.elements) === null || _b === void 0 ? void 0 : _b.length) > 0; };
export const getTotalPriceFilteredElements = (elements, type, currency) => {
    if (!(elements === null || elements === void 0 ? void 0 : elements.length)) {
        return getZeroPrice(currency);
    }
    const filteredElements = elements.filter(element => element.type === type);
    return filteredElements.length > 0
        ? getTotalPrice(filteredElements, filteredElements => filteredElements.money)
        : getZeroPrice(currency);
};
export const getZeroPrice = (currency) => {
    const zeroPrice = {
        amount: 0,
        currency: getCurrency()
    };
    if (currency in Currency) {
        zeroPrice.currency = currency;
    }
    return zeroPrice;
};
